import { rei } from "@/services/api"

class FunerariasService {
  static getFunerarias (params = null) {
    if (params == null) {
      return rei.get(`funerarias`).then(res => res.data)
    } else {
      let query = []
      query.push(params.perPage ? 'perPage=' + params.perPage : '')
      query.push(params.page ? 'page=' + params.page : '')
      query.push(params.nome ? 'nome=' + params.nome : '')
      query.push(params.cartorio_id ? 'cartorio_id=' + params.cartorio_id : '')
      return rei.get(`funerarias?${query.join('&')}`).then(res => res.data)
    }
  }

  static saveFunerarias (funeraria) {
    return rei.post(`funerarias`, funeraria).then(res => res.data)
  }

  static updateFunerarias (funeraria, id) {
    return rei.put(`funerarias/${id}`, funeraria).then(res => res.data)
  }

  static excludeFuneraria (id) {
    return rei.delete(`funerarias/${id}`)
  }

  static getLastFuneraria () {
    return rei.get(`ultima-funeraria`).then((res) => res.data)
  }
}

export default FunerariasService
